import { useEffect, useState } from "react";
import { useEnvironment } from "../../../core/Global";
import FlexRow from "../../base/FlexRow";

function AsideBrand() {

    const env = useEnvironment();

    const [sidebarToggled, sidebarToggledSet] = useState<boolean>(false);

    // useEffect(() => {
    //     var t = localStorage.getItem("sidebarToggled");
    //     if (t == "True") {
    //         $("#kt_aside_toggle").click();
    //     }
    // }, [])

    useEffect(() => {
        if (sidebarToggled) {
            //localStorage.setItem("sidebarToggled", "True");
            setTimeout(() => {
                $("#kt_aside").addClass("aside-hoverable");
            }, 100);
        }
        else {
            //localStorage.setItem("sidebarToggled", "False");
            $("#kt_aside").removeClass("aside-hoverable");
        }
    }, [sidebarToggled])
    return (
        <div className="aside-logo" id="kt_aside_logo">
            <FlexRow column>
                <img src={`/assets/brands/${env.brand}/icon.png`} className="w-35px logo mb-2" />
                <span className="fw-bolder fs-7 text-white">
                    {env.brand.toUpperCase()}
                </span>
            </FlexRow>
        </div>
    )
}

export default AsideBrand;